import { gql } from '@apollo/client';

// iOS / Android store links from the backend
export const GET_DOWNLOAD_URLS = gql`
  query {
    getCashkingsDownloadUrls {
      ios
      android
    }
  }
`;
